<!-- =========================================================================================
    FileName: ResetPassword.vue,
    Description: ResetPassword Page,
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
    <div>
      <div class="page_header_wrap" :class="{ filters_open: filtersList }">
        <div class="page_header">
          <div>
            <h2 ><a><img src="@/assets/images/pages/arrow.png"></a>Support Cases</h2>
          </div>
          <!-- <div  v-if="importData">
          <form @submit.prevent>
           <file-upload v-model="fileDoc" class="file-upload-input"
                      accept=""  :name="'importfile'" data-vv-as="Upload SDK files"
                        @input="uploadLocalFile(fileDoc)" >
                        <img class="file-icon" src="@/assets/images/file-icons/file-upload.svg"> Upload test
                      </file-upload>
          </form>
        </div> -->
          <div class="page_actions"> 
            <button class="primary_btn export_btn " style="cursor:pointer" >
                  <file-upload v-model="fileDoc" class="file-upload-input d-flex align-center"
                      :accept="acceptedFiles"  :name="'importfile'" data-vv-as="Upload SDK files"
                        @input="uploadLocalFile(fileDoc)" >
                        <img class="file-icon" src="@/assets/images/pages/import.png"> Import
                      </file-upload>
                     
            </button>
            <!-- <button class="secondary_btn" @click="importData =!importData">Import</button> -->
            <button style="cursor:pointer"  class="primary_btn export_btn loadersec mr-4 ml-4" @click="exportList()"> 
              <img  src="@/assets/images/pages/export.png">
              Export
               <span class="loader" v-if="isExport"><img  src="@/assets/images/pages/loader.gif" /></span>
            </button>
            <button :disabled="getAactiveCustomer!=null" v-if="(activeUserInfo && (activeUserInfo.roleId == 2 || activeUserInfo.roleId == 1))  " class="secondary_btn add" @click="openCreatePop">
              Create Support Case
            </button>
            <button  class="secondary_btn filters_btn" :class="{ active: filtersList }" @click="filtersList = !filtersList">
              <span class="material-icons"> filter_list</span>Filters
            </button>
          </div>
        </div> 
        <div class="admin_header_options">
            <div class="admin_header_options-in">   
            <!-- <figure><img src="@/assets/images/pages/support.jpg" alt="support" class="mx-auto"></figure> -->
            <ul>
              <li>            
                <label class="td_status new"><span>{{stats[1]}}</span>New</label> 
              </li>
              <li>            
                <label class="td_status inprogress"><span>{{stats[2]}}</span>In Process</label>
              </li>
              <li>
                
                <label class="td_status closed"><span>{{stats[3]}}</span>Closed</label>
              </li>
              <li>
                
                <label class="td_status rejected"><span>{{stats[4]}}</span>Rejected</label>
              </li>          
              <li>            
                <label class="td_status defered"><span>{{stats[5]}}</span>Deferred</label>
              </li>
              
              <li>            
                <label class="td_status resloved"><span>{{stats[6]}}</span>Resolved </label>
              </li>
              <li>            
                <label class="td_status reopen"><span>{{stats[7]}}</span>Reopened</label>
              </li>
              
            </ul>
            </div> 
            <!-- {{exportPath}} -->
          </div>
        <div class="filter_layer" @click="filtersList = !filtersList"></div>
        <div
      ref="filterCard"
      title="Filters"
      class="user-list-filters filters_list"
      actionButtons
      @refresh="resetColFilters"
      @remove="resetColFilters"
    >
      <div class="vx-row">
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full marb10">
          <label class="text-sm opacity-75">Status</label>
          <multiselect
            v-model="filterData.statusIds"
            :options="status_list"
            :close-on-select="false"
            :clear-on-select="false"
            :hide-selected="true"
            :preserve-search="true"
            placeholder="Select"
            label="name"
            track-by="name"
            :preselect-first="true"
            id="status"
            :multiple="true"
          >
            <template slot="selection" slot-scope="{ values, isOpen }">
              <span
                class="multiselect__selectcustom"
                v-if="values.length && !isOpen"
                >{{ values.length }} Status(es) selected</span
              >
              <span
                class="multiselect__selectcustom"
                v-if="values.length && isOpen"
              ></span>
            </template>
            <span slot="noResult">No Statuses Found</span>
          </multiselect>
          <!--<v-select :options="statusOptions" :clearable="false" 
            :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="statusFilter" class="mb-4 md:mb-0" />-->
        </div>   
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full marb10">
          <label class="text-sm opacity-75">Created Date</label>
          <date-range-picker :autoApply="autoApply" :maxDate="maxDate" 
          :ranges="false" v-model="selected_createdDateRange" placeholder="Select Range"></date-range-picker>
        </div> 
        <template v-if="activeUserInfo && activeUserInfo['roleId'] ==1">  
            <div  class="vx-col md:w-1/4 sm:w-1/2 w-full marb10">
          <label class="text-sm opacity-75">Company</label>
          <multiselect
            v-model="filterData.companyIds"
            :options="companies"
            :close-on-select="false"
            :clear-on-select="false"
            :hide-selected="true"
            :preserve-search="true"
            placeholder="Select "
            label="name"
            track-by="name"
            :preselect-first="true"
            id="status"
            :multiple="true"
            @input="filterData.projectIds=[];getCustomerList()"
          >
            <template slot="selection" slot-scope="{ values, isOpen }">
              <span
                class="multiselect__selectcustom"
                v-if="values.length && !isOpen"
                >{{ values.length }} Company(s) selected</span
              >
              <span
                class="multiselect__selectcustom"
                v-if="values.length && isOpen"
              ></span>
            </template>
            <span slot="noResult">No Companies Found</span>
          </multiselect>
          <!--<v-select :options="statusOptions" :clearable="false" 
            :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="statusFilter" class="mb-4 md:mb-0" />-->
            </div>
            </template>
<template> 
            <div   class="vx-col md:w-1/4 sm:w-1/2 w-full marb10">
              <label class="text-sm opacity-75">Projects </label>
              <multiselect
                v-model="filterData.projectIds"
                :options="companyProjects"
                :close-on-select="false"
                :clear-on-select="false"
                :hide-selected="true"
                :preserve-search="true"
                placeholder="Select"
                label="name"
                track-by="name"
                :preselect-first="true"
                id="project"
                :multiple="true"
                
              >
                <template slot="selection" slot-scope="{ values, isOpen }">
                  <span
                    class="multiselect__selectcustom"
                    v-if="values.length && !isOpen"
                    >{{ values.length }} Projects(s) selected</span
                  >
                  <span
                    class="multiselect__selectcustom"
                    v-if="values.length && isOpen"
                  ></span>
                </template>
                <span slot="noResult">No Projects Found</span>
              </multiselect>
            </div>


        </template>

        
         <div class="vx-col md:w-1/4 sm:w-1/2 w-full marb10" v-if="activeUserInfo.roleId == 1" >
        
          <label class="text-sm opacity-75">Users</label>
         
          <multiselect
            v-model="filterData.customerIds"
            :options="customerList"
            :close-on-select="false"
            :clear-on-select="false"
            :hide-selected="true"
            :preserve-search="true"
            placeholder="Select"
            label="name"
            track-by="name"
            :preselect-first="true"
            id="Product"
            :multiple="true"
             @search-change="searchCustomerList"
          >
            <template slot="selection" slot-scope="{ values, isOpen }">
              <span
                class="multiselect__selectcustom"
                v-if="values.length && !isOpen"
                >{{ values.length }} User(s) selected</span
              >
              <span
                class="multiselect__selectcustom"
                v-if="values.length && isOpen"
              ></span>
            </template>
            <span slot="noResult">No Users Found</span>
          </multiselect>
           
        </div>
        

        
        
        


        <div class="vx-col md:w-1/4 sm:w-1/2 w-full marb10">
                <label class="text-sm opacity-75">Device Family</label>
                <multiselect
                  v-model="filterData.deviceFamDetails"
                  :options="device_family"
                  :close-on-select="false"
                  :clear-on-select="false"
                  :hide-selected="true"
                  :preserve-search="true"
                  placeholder="Select "
                  label="name"
                  track-by="name"
                  :preselect-first="true"
                  id="status"
                  :multiple="true"
                >
                  <template slot="selection" slot-scope="{ values, isOpen }">
                    <span
                      class="multiselect__selectcustom"
                      v-if="values.length && !isOpen"
                      >{{ values.length }} Device Family(s) selected</span
                    >
                    <span
                      class="multiselect__selectcustom"
                      v-if="values.length && isOpen"
                    ></span>
                  </template>
                  <span slot="noResult">No Device Families Found</span>
                </multiselect>
          
        </div>

        <div class="vx-col md:w-1/4 sm:w-1/2 w-full marb10">
                <label class="text-sm opacity-75">Case Type</label>
                <multiselect
                  v-model="filterData.typeDetails"
                  :options="ticket_type"
                  :close-on-select="false"
                  :clear-on-select="false"
                  :hide-selected="true"
                  :preserve-search="true"
                  placeholder="Select "
                  label="name"
                  track-by="name"
                  :preselect-first="true"
                  id="status"
                  :multiple="true"
                >
                  <template slot="selection" slot-scope="{ values, isOpen }">
                    <span
                      class="multiselect__selectcustom"
                      v-if="values.length && !isOpen"
                      >{{ values.length }} Case Type(s) selected</span
                    >
                    <span
                      class="multiselect__selectcustom"
                      v-if="values.length && isOpen"
                    ></span>
                  </template>
                  <span slot="noResult">No Case Types Found</span>
                </multiselect>
          
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full marb10">
                <label class="text-sm opacity-75">Case Priority</label>
                <multiselect
                  v-model="filterData.priorityDetails"
                  :options="ticket_priority"
                  :close-on-select="false"
                  :clear-on-select="false"
                  :hide-selected="true"
                  :preserve-search="true"
                  placeholder="Select "
                  label="name"
                  track-by="name"
                  :preselect-first="true"
                  id="Priority"
                  :multiple="true"
                >
                  <template slot="selection" slot-scope="{ values, isOpen }">
                    <span
                      class="multiselect__selectcustom"
                      v-if="values.length && !isOpen"
                      >{{ values.length }} Case Priority(s) selected</span
                    >
                    <span
                      class="multiselect__selectcustom"
                      v-if="values.length && isOpen"
                    ></span>
                  </template>
                  <span slot="noResult">No Case Priorities Found</span>
                </multiselect>
          
        </div>

        <div class="vx-col md:w-1/4 sm:w-1/2 w-full marb10">
                <label class="text-sm opacity-75">Versions</label>
                <multiselect
                  v-model="filterData.versionDetails"
                  :options="versions"
                  :close-on-select="false"
                  :clear-on-select="false"
                  :hide-selected="true"
                  :preserve-search="true"
                  placeholder="Select "
                  label="name"
                  track-by="name"
                  :preselect-first="true"
                  id="Priority"
                  :multiple="true"
                >
                  <template slot="selection" slot-scope="{ values, isOpen }">
                    <span
                      class="multiselect__selectcustom"
                      v-if="values.length && !isOpen"
                      >{{ values.length }} Case version(s) selected</span
                    >
                    <span
                      class="multiselect__selectcustom"
                      v-if="values.length && isOpen"
                    ></span>
                  </template>
                  <span slot="noResult">No versions Found</span>
                </multiselect>
          
        </div>

        <div class="vx-col md:w-1/4 sm:w-1/2 w-full marb10">
                <label class="text-sm opacity-75">Areas</label>
                <multiselect
                  v-model="filterData.areaDetails"
                  :options="Areas"
                  :close-on-select="false"
                  :clear-on-select="false"
                  :hide-selected="true"
                  :preserve-search="true"
                  placeholder="Select "
                  label="name"
                  track-by="name"
                  :preselect-first="true"
                  id="Priority"
                  :multiple="true"
                >
                  <template slot="selection" slot-scope="{ values, isOpen }">
                    <span
                      class="multiselect__selectcustom"
                      v-if="values.length && !isOpen"
                      >{{ values.length }} Case Area(s) selected</span
                    >
                    <span
                      class="multiselect__selectcustom"
                      v-if="values.length && isOpen"
                    ></span>
                  </template>
                  <span slot="noResult">No Areas Found</span>
                </multiselect>
          
        </div>

         <div class="vx-col md:w-1/4 sm:w-1/2 w-full marb10">
        <label class="text-sm opacity-75">Search</label>
          <input
           v-model="filterData.title"
            class="search_field" 
            type="text"
            @keyup.enter="onEnter"
            placeholder="Search By Subject"
          />
         <!--  @input="apply_filter(filterData)" -->
        </div>
        <template v-if="activeUserInfo.roleId ==1" >
             <div class="vx-col md:w-1/4 sm:w-1/2 w-full marb10" ></div>
              <div class="vx-col md:w-1/4 sm:w-1/2 w-full marb10" ></div>
            <div class="vx-col md:w-1/4 sm:w-1/2 w-full marb10"  ></div>
            <div class="vx-col md:w-1/4 sm:w-1/2 w-full marb10"  ></div>
        </template>
        <div class="vx-col md:w-2/4 sm:w-1/2 w-full marb10" v-if="activeUserInfo.roleId == 2"></div>
        <div class="vx-col md:w-3/4 sm:w-1/2 w-full marb10" v-if="activeUserInfo.roleId == 3" ></div>
      <!--  <label class="text-sm opacity-75">Shared With</label>
           <multiselect
            v-model="filterData.sharedToIdDetails"
            :options="companyUsersList"
            :close-on-select="false"
            :clear-on-select="false"
            :hide-selected="true"
            :preserve-search="true"
            placeholder="Select "
            label="name"
            track-by="name"
            :preselect-first="false"
            id="status"
            :multiple="true"
             @search-change="getComapnyUsers"
              :disabled="activeUserInfo.roleId != 2"
          >
            <template slot="selection" slot-scope="{ values, isOpen }">
              <span
                class="multiselect__selectcustom"
                v-if="values.length && !isOpen"
                >{{ values.length }} User(s) selected</span
              >
              <span
                class="multiselect__selectcustom"
                v-if="values.length && isOpen"
              ></span>
            </template>
            <span slot="noResult">No Users Found</span>
          </multiselect> 
          -->
        
       
         
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full d-flex align-end justify-end padt10 marb10 ">
           <button @click="clearFilters()" class="secondary_btn">
            Clear
          </button>
          <button class="primary_btn marl15" @click="apply_filter(filterData) ; filtersList = !filtersList">
            Apply
          </button>
        </div>
        
      </div>
    </div>
      </div>


      
      <!--
      v-if="activeUserInfo.roleId ==2" 
      <vx-card ref="filterCard" title="Filters" class="user-list-filters mb-8" actionButtons @refresh="resetColFilters" @remove="resetColFilters">
      <div class="vx-row"> 
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full d-flex justify-end align-end" >
          <input class="search_field" type="text" placeholder="Search">
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">Status</label>
          <v-select :options=" statusOptions" :clearable="false" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="statusFilter" class="mb-4 md:mb-0" />
        </div>
        
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">Created on</label>
             <date-range-picker
            ref="picker"
            :opens="opens"
            :locale-data="{ firstDay: 1, format: 'DD-MM-YYYY HH:mm:ss' }"
            :minDate="minDate" :maxDate="maxDate"
            :singleDatePicker="singleDatePicker"
            :timePicker="timePicker"
            :timePicker24Hour="timePicker24Hour"
            :showWeekNumbers="showWeekNumbers"
            :showDropdowns="showDropdowns"
            :autoApply="autoApply"
            v-model="dateRange"
            @update="updateValues"
            @toggle="checkOpen"
            :linkedCalendars="linkedCalendars"
            :dateFormat="dateFormat"
    >
        <template v-slot:input="picker" style="min-width: 350px;">
            {{ picker.startDate | date }} - {{ picker.endDate | date }}
        </template>
    </date-range-picker>
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full d-flex justify-end align-end">
              <button class="primary_btn">Apply</button>
           </div>
      </div>
    </vx-card>-->

    
    <vs-table class="table_list" :data="list" noDataText=""  > 
      <template slot="thead">
        <vs-th>
            <span>
              <a
                @click="sortMe('customId')"
                v-bind:class="{
                  sort_ascending: sortKeys['customId'] == 1,
                  sort_descending: sortKeys['customId'] != 1,
                }"
                >Case ID</a
              >
            </span>
        </vs-th>
        
        <vs-th>
            <span>
              <a
                @click="sortMe('title')"
                v-bind:class="{
                  sort_ascending: sortKeys['title'] == 1,
                  sort_descending: sortKeys['title'] != 1,
                }"
                >Subject</a
              >
            </span>
        </vs-th>
        <template >
         
        <vs-th >
           <span>
              <a
                @click="sortMe('projectName')"
                v-bind:class="{
                  sort_ascending: sortKeys['projectName'] == 1,
                  sort_descending: sortKeys['projectName'] != 1,
                }"
                >Project</a
              >
            </span>
          
        </vs-th>

        
        </template>
       
       
        <vs-th>
           <span>
              <a
                @click="sortMe('statusName')"
                v-bind:class="{
                  sort_ascending: sortKeys['statusName'] == 1,
                  sort_descending: sortKeys['statusName'] != 1,
                }"
                >Status</a
              >
            </span>
          
        </vs-th>
        
       
        <vs-th>Case Type</vs-th>
        <vs-th v-if="activeUserInfo.roleId ==1"> Company</vs-th>
         <vs-th v-if="activeUserInfo.roleId == 1">
          Assigned To
        </vs-th>

         <vs-th>
           <span>
              <a
                @click="sortMe('createdByName')"
                v-bind:class="{
                  sort_ascending: sortKeys['createdByName'] == 1,
                  sort_descending: sortKeys['createdByName'] != 1,
                }"
                >Created By</a
              >
            </span>
          
        </vs-th>

         <vs-th>

           <span>
              <a
                @click="sortMe('updatedOn')"
                v-bind:class="{
                  sort_ascending: sortKeys['updatedOn'] == 1,
                  sort_descending: sortKeys['updatedOn'] != 1,
                }"
                >Updated On</a
              >
            </span>
        </vs-th>
        <vs-th>
          Action
        </vs-th>
      </template>

      <template v-if="list && list.length > 0">
        <vs-tr v-for="(item, index) in list" :key="index"> 
          <vs-td class="ticket_id">
           <router-link
                    :to="'/support-case-details/'+item['_id']"
                    > {{item.customId}}
                    </router-link> 

                    
                    <!--https://deepvisioncs.atlassian.net/browse/DEEP-26-->
                    <span style="cursor:pointer"  @click="goTojira(item['jiraKey'])" v-if="activeUserInfo && activeUserInfo.roleId==1 && ( item['jiraKey'] &&  item['jiraKey'] !='')" class="jira_syc">{{item['jiraKey']}}</span>
           
          </vs-td>

          <vs-td>
         
           <template v-if="item.title">
         
              <div class="description" v-html="item.title" ></div>
           </template>
          
           </vs-td>
          <!-- <vs-td><span v-html="getDescription(item)" class="description"></span> </vs-td> -->
          <template >
              <vs-td >
              <template v-if="checkProperty(item ,'projectDetails' ,'name')"> {{item.projectDetails.name}}</template>
              
              </vs-td>
              
          </template> 
          
          <vs-td >
            <span class="td_status" :class="{'new':item.statusId==1 , 'inprogress':item.statusId==2 , 'closed':item.statusId== 3 , 'rejected':item.statusId==4, 'defered':item.statusId==5 ,'resloved':item.statusId==6 ,'reopen':item.statusId==7}"
              >
              <template  v-if="item.statusDetails">
              {{item.statusDetails.name}}
              </template>
            </span> 
          </vs-td>
         
          <!-- <vs-td v-if="activeUserInfo && activeUserInfo.roleId != 2">
           {{ item.createdByDetails.name }}
          </vs-td> -->
          <vs-td>
            <template v-if="item.typeDetails">  
                  {{ item.typeDetails.name }}
             </template>
          
          </vs-td>
           <vs-td v-if="activeUserInfo && activeUserInfo.roleId ==1"> 
             <template v-if="item.createdByDetails['companyDetails']"> 
                <div class="description">{{ item.createdByDetails['companyDetails'].name }}</div>
             </template>
              <template v-else-if="item['companyDetails']"> 
                <div class="description">{{ item['companyDetails'].name }}</div>
             </template>
             <!-- <template v-else> 
                -
             </template> -->
          
          </vs-td>
          
          <vs-td v-if="activeUserInfo && activeUserInfo.roleId == 1">
          
            <ul class="td_addigned_list"> 
            <template v-if="checkProperty(item ,'assignEmpDetails')">
                <template v-for="(item1, ind) in item.assignEmpDetails">
                <li :key="ind" v-if="ind < 1" >
                  <div class="td_addigned_name">
                    <span>{{ item1.shortName }}</span>
                    <label>{{ item1.name }}</label>
                  </div>

                  <!-- <vs-dropdown >
                    <a class="a-icon" href.prevent><span >{{ item1.shortName }}</span></a>
                    <vs-dropdown-menu>
                      <vs-dropdown-item>{{ item1.name }}</vs-dropdown-item>
                    </vs-dropdown-menu>
                  </vs-dropdown> -->
                </li>
             
                </template>
              </template>  
              <li v-if=" checkProperty(item ,'assignEmpDetails') &&  item.assignEmpDetails.length > 1">
                <!-- <div class="td_addigned_name">
                  <span class="more">{{ item.assignEmpDetails.length - 1 }}+</span>
                  <ul >
                      <li v-for="(item1, ind) in item.assignEmpDetails" :key="ind"> 
                        <template v-if="ind >= 1" >{{ item1.name }}</template>
                      </li> 
                  </ul>
                </div> -->
                
                <vs-dropdown vs-trigger-click>
                   <template v-if="item.assignEmpDetails.length > 1">
                      <a class="a-icon more" href.prevent> 
                  <span>{{ item.assignEmpDetails.length - 1 }}+</span>
                </a>               
                 </template>   

                <vs-dropdown-menu>
                  <vs-dropdown-item  v-if="item.assignEmpDetails.length > 1">
                     <template v-for="(item1, ind) in item.assignEmpDetails">
                          <span class="list_item padtb5" v-if="ind >= 1" :key="ind">{{ item1.name }}</span>
                                                      
                            </template>
                 
                    </vs-dropdown-item>

                     
                </vs-dropdown-menu>
              </vs-dropdown>


                <!-- <vs-dropdown>
                   <template v-if="item.assignEmpDetails.length > 1">
                      <a class="a-icon more" href.prevent> 
                  <span>{{ item.assignEmpDetails.length - 1 }}+</span>
                </a>               
                 </template>               
                <vs-dropdown-menu>
                  <vs-dropdown-item  v-if="item.assignEmpDetails.length > 1">
                     <template v-for="(item1, ind) in item.assignEmpDetails">
                          <span class="list_item padtb5" v-if="ind >= 1" :key="ind">{{ item1.name }}</span>
                                                      
                            </template>
                 
                    </vs-dropdown-item>
                </vs-dropdown-menu>
              </vs-dropdown> -->
              </li>
            </ul>
          </vs-td>

          <vs-td>
          <div class="description"> {{ item.createdByDetails.name }}</div>
          </vs-td>

          <vs-td> <span v-if="item.updatedOn">
              {{item.updatedOn | formatDate}}
              <br>
              <small>{{ item.updatedOn | formatTime}}</small> 
            </span>
            <!-- <span v-else> -
            </span> -->
          </vs-td>

          <vs-td> 
            <vs-dropdown vs-trigger-click>
              <a class="a-icon" href.prevent> 
                <span class="material-icons">more_vert</span>
              </a>

              <vs-dropdown-menu>

              <vs-dropdown-item  v-if="item.statusId != 3 && activeUserInfo.roleId != 1 &&activeUserInfo.roleId != 2 " @click="viewAsCustomer(item['createdByDetails'])"  ><span>View as Customer</span></vs-dropdown-item>
                 
               <vs-dropdown-item :disabled="getAactiveCustomer!=null"  v-if="((userdata.roleId ==1 || (activeUserInfo && activeUserInfo.roleId == 2 && item['createdBy']==userdata.userId) || ( checkProperty(item ,'owners') && item['owners'] && item['owners'].indexOf(userdata.userId) >-1  ) ) && item.statusId!= 3)"><span @click="editMe(item)">Edit </span></vs-dropdown-item>
               
                <vs-dropdown-item v-if="userdata.roleId ==1 && !transferToJiraCheck(item) && (checkProperty(item ,'typeId') ==false || checkProperty(item ,'typeId') !=3)"><span @click="openAddtogira(item)">Transfer To JIRA </span></vs-dropdown-item>
                <vs-dropdown-item>
                  <router-link
                    :to="'/support-case-details/'+item['_id']"
                    ><span>Details</span>
                  </router-link>
                </vs-dropdown-item>
                <vs-dropdown-item v-if="activeUserInfo && activeUserInfo.roleId == 1">
                  <a  @click="openAssignPopup(item)"><span>Assign To</span></a>
                </vs-dropdown-item>
              </vs-dropdown-menu>
            </vs-dropdown>
          </vs-td>  
        </vs-tr>
      </template>
        <template v-else>
          <tr v-if="!loading">
            <td class="center-align" colspan="9">No Support Cases Found!</td>
          </tr>
        </template>
    </vs-table>
      <div class="pagination_wrap" >
        <div class="pagination_content">
          <h6>Show Records</h6>
         <!--  <v-select
            @input="change_perPage()"
            v-model="perPage"
            :options="perPeges"
            label="Per Page"
            solo
          ></v-select> -->

          <multiselect
            :multiple="false" 
              @input="change_perPage()"
            placeholder="Page"
            
            :close-on-select="true"
            :clear-on-select="false"
            :hide-selected="true"
            :preserve-search="true"
            v-model="perPage" :options="perPeges" >
              <template slot="selection" slot-scope="{ values, isOpen }">
                <span
                  class="multiselect__selectcustom"
                  v-if="values.length && !isOpen"
                  >{{ values.length }} selected</span
                >
                <span
                  class="multiselect__selectcustom"
                  v-if="values.length && isOpen"
                ></span>
              </template>
              
            </multiselect>
        </div>
        <vs-pagination
          :total="totalPages"
          :max="7"
          v-model="page"
          @input="ticketcompanyUpdatedPriviously =false;getList()"
        />
      </div>

    <vs-popup class="holamundo" :active.sync="popupcreateticket"  :title="isEdit?'Edit Support Case':'New Support Case'">
      <div class="createticket_form form_section support_ticket">

        <!--<template>
  <div id="app">
    <froala id="edit" :tag="'textarea'" :config="config" v-model="model"></froala>
  </div>
</template>-->


        <form autocomplete="off" >
          <ul>
            <li>
              <div class="form-group">
                <label class="form_label">Subject*</label>
                <vs-input
                  v-validate="'required|max:50'"
                  name="Subject"
                   
                  icon-no-border
                  icon-pack="feather"
                  v-model="ticket.title"
                  class="w-full"
                 :disabled="(isEdit && (checkProperty(selectedItem ,'jiraId')!=false || checkProperty(selectedItem ,'jiraId') !='' ))"
                />
                <span class="text-danger text-sm">{{
                  errors.first("Subject")
                }}</span>
              </div>
            </li>

           <template v-if="activeUserInfo.roleId ==1" >
              <li class="col-2"> 
              <div class="taggable">
                <div class="form-group">
                
                <label class="form_label">Company</label>
                  <multiselect
                  v-model="ticket.selectedCompany"
                  :options="companies"
                  :close-on-select="true"
                  :clear-on-select="false"
                  :hide-selected="true"
                  :preserve-search="true"
                  placeholder="Select Company"
                  label="name"
                  track-by="name"
                  :preselect-first="false"
                  id="status"
                  :multiple="false"
                  @input="getCompanyProjects(true)"
                  :disabled="activeUserInfo.roleId==1 && isEdit"
                 
                >
                  <template slot="selection" slot-scope="{ values, isOpen }">
                    <span
                      class="multiselect__selectcustom"
                      v-if="values.length && !isOpen"
                      >{{ values.length }} Company(s) selected</span
                    >
                    <span
                      class="multiselect__selectcustom"
                      v-if="values.length && isOpen"
                    ></span>
                  </template>
                  <span slot="noResult">No Companies Found</span>
                </multiselect>
                </div>
              </div>
              </li>
          </template>

            
            <li class="col-2"> 
              <div class="taggable">
                <div class="form-group">
                <label class="form_label">Project</label>
                  <multiselect 
                    v-model="ticket.selectedProject" 
                    :options="projects" 
                    :clear-on-select="false"
                     :allow-empty="true"
                    :hide-selected="false"
                    :preserve-search="true"
                    placeholder="Select Project"
                    label="name"
                    name="Project"
                    track-by="name"
                    id="project"
                    :disabled="!([1,2].indexOf(activeUserInfo.roleId)>-1)"
                    @input="projectChanged()"
                      >
                    <template slot="selection" slot-scope="{ values, isOpen }">
                      <span class="multiselect__selectcustom" 
                      v-if="values.length && !isOpen">{{ values.length }} Project(s) selected</span>
                      <span class="multiselect__selectcustom" v-if="values.length && isOpen"></span>
                    </template>
                    <span slot="noResult">No Projects Found</span>
                  </multiselect>
                </div>
              </div>
            </li>
<!--------------CHANGES STARTED-------------->
           
            
             

            <li class="col-2">
             
              <div class="form-group">
              <label class="form_label">Device Family </label>
            <multiselect 
             placeholder="Select Device Family"
            :searchable="true"
            :allow-empty="true"
            :hide-selected="false"
            @input="changedDevice"
            name="Device Family"
            :multiple="false" 
            label="name"
            id="deviceFam"
            track-by="name" 
            v-model="deviceFamDetails" :options="device_family" >
           <span slot="noResult">No Device Family Found</span>
            </multiselect>
            <!--  <span class="text-danger text-sm">{{
                errors.first("Device Family")
              }}</span>--->
              </div>
            </li>
            
            <li class="col-2">
              <div class="form-group">
             <label class="form_label">Case Area </label>
              <multiselect
              placeholder="Select Case Area"
            :searchable="true"
            :allow-empty="true"
            :hide-selected="false"
            @input="changedArea"
            name="area"
            :multiple="false" 
            label="name"
            id="ticketArea"
            track-by="name" 
            v-model="areaDetails" :options="Areas" >
             <span slot="noResult">No Areas Found</span>
            </multiselect>
              <!---<span class="text-danger text-sm">{{
                errors.first("area")
              }}</span>--->
              </div>
            </li>

            <li class="col-2">
                   
              <div class="form-group">
              <label class="form_label">Version Details </label>
            <multiselect
             :searchable="true"
            :allow-empty="true"
            :hide-selected="false"
            @input="changedVersion"
            name="version"
            :multiple="false" 
            label="name"
            track-by="name"
            placeholder="Select Version"
            id="version"
            v-model="versionDetails" :options="versions" >
            <span slot="noResult">No Versions Found</span>
            </multiselect>
              <span class="text-danger text-sm">{{
                errors.first("Version")
              }}</span>
              <!---<span class="text-danger text-sm">{{
                errors.first("version")
              }}</span>--->
              </div>
            </li>
            <li class="col-2">
              
              <div class="form-group">
              <label class="form_label">Case Priority* </label>
            <multiselect
            v-validate="'required'"
            placeholder="Select Case Priority"
            :searchable="true"
            :allow-empty="false"
            :hide-selected="false"
            @input="changedPriority"
            name="Case Priority"
            :multiple="false" 
            label="name"
            track-by="name" 
            id="ticketPriority"
            v-model="priorityDetails" :options="ticket_priority" >
            <span slot="noResult">No Case Priority Found</span>
            </multiselect>
             <span class="text-danger text-sm">{{
                errors.first("Case Priority")
              }}</span>
              </div>
            </li>


            <li class="" :class="{' cl':(activeUserInfo.roleId==1 && isEdit) ,'col-2':(activeUserInfo.roleId==1 && !isEdit) || activeUserInfo.roleId==2}" >
             
              <div class="form-group">
              <label class="form_label">Case Type* </label>
            <multiselect
            placeholder="Select Case Type"
             v-validate="'required'"
             :searchable="true"
            :allow-empty="false"
            :hide-selected="false"
            @input="changedType"
            name="Case Type"
            :multiple="false" 
            label="name"
            id="ticketType"
            track-by="name"
            :disabled="(isEdit && (checkProperty(selectedItem ,'jiraId')!=false || checkProperty(selectedItem ,'jiraId') !='' ))" 
            v-model="ticketTypeDetails" :options="ticket_type" >
              <span slot="noResult">No Types Found</span>
            </multiselect>
             <span class="text-danger text-sm">{{
                errors.first("Case Type")
              }}</span>
              </div>
             
            </li>

            <template >
             <li class="col-2" v-if="activeUserInfo.roleId==1 && !isEdit"> 
              <div class="taggable">
             
                <div class="form-group">
                
                <label class="form_label">Assign To</label>
                  <multiselect
            v-model="assignedTo"
            :options="employeeList"
            :close-on-select="false"
            :clear-on-select="false"
            :hide-selected="true"
            :preserve-search="true"
            placeholder="Select "
            label="name"
            track-by="name"
            :preselect-first="false"
            id="status"
            :multiple="false"
            @input="changedAssignTo"
            
          >
            <template slot="selection" slot-scope="{ values, isOpen }">
              <span
                class="multiselect__selectcustom"
                v-if="values.length && !isOpen"
                >{{ values.length }} User(s) selected</span
              >
              <span
                class="multiselect__selectcustom"
                v-if="values.length && isOpen"
              ></span>
            </template>
            <span slot="noResult">No Users Found</span>
          </multiselect>
                </div>
              </div>
             </li>
             <li class=""  v-if="activeUserInfo.roleId==2"> 
              <div class="taggable">
             
                <div class="form-group">
                <label class="form_label">Users</label>
                  <multiselect
            v-model="usersIdDetails"
            :options="companyUsersList"
            :close-on-select="false"
            :clear-on-select="false"
            :hide-selected="true"
            :preserve-search="true"
            placeholder="Select "
            label="name"
            track-by="name"
            :preselect-first="false"
            id="status"
            :multiple="true"
             @search-change="getComapnyUsers"
              :disabled="activeUserInfo.roleId !=2"
          >
            <template slot="selection" slot-scope="{ values, isOpen }">
              <span
                class="multiselect__selectcustom"
                v-if="values.length && !isOpen"
                >{{ values.length }} User(s) selected</span
              >
              <span
                class="multiselect__selectcustom"
                v-if="values.length && isOpen"
              ></span>
            </template>
            <span slot="noResult">No Users Found</span>
          </multiselect>
                </div>
              </div>
             </li>
            </template> 
            

            <!---------------------------------->

            <li>
              <div class="form-group">
              <label class="form_label">Description* </label>
            
                <ckeditor
                 v-validate="'required'"
                  name="Description"
                 :disabled="(isEdit && (checkProperty(selectedItem ,'jiraId')!=false || checkProperty(selectedItem ,'jiraId') !='' ))" :editor="editor" v-model="ticket.description" :config="editorConfig"></ckeditor>
                  
                  <span class="text-danger text-sm">{{
                  errors.first("Description")
                }}</span>
              </div>
            </li>

            <li>
              <div class="form-group">
                <label v-if="(!(!isEdit || !(checkProperty(selectedItem ,'jiraId')!=false ||
                 checkProperty(selectedItem ,'jiraId') !='' )) && ticket.documents && ticket.documents.lenth > 0) ||
                 (!isEdit || !(checkProperty(selectedItem ,'jiraId')!=false || checkProperty(selectedItem ,'jiraId') !='' ))
                 " class="form_label"> Documents</label>
                <div v-if="!isEdit || !(checkProperty(selectedItem ,'jiraId')!=false ||
                 checkProperty(selectedItem ,'jiraId') !='' )" @click="documents=[]" class="files_wrap"> 
                      <file-upload v-model="documents" class="file-upload-input"
                      accept=""  :name="'files'" data-vv-as="Upload SDK files"
                        :multiple="true" @input="upload(documents)" >
                        <img class="file-icon" src="@/assets/images/file-icons/file-upload.svg"> Upload
                      </file-upload>
                      <span class="text-danger text-sm"
                      v-show="errors.has('files')">{{ errors.first('files') }}</span>
                </div>
                <ul  class="uploaded-list">
                  <li v-if="!isEdit || !(checkProperty(selectedItem ,'jiraId')!=false || checkProperty(selectedItem ,'jiraId') !='' )"><vs-chip @click="remove(indx)" :name="'fileRemoveSelected'" 
                  v-for="(other, indx) in ticket.documents" :key="indx"  closable> {{ other.name }}</vs-chip></li>
                   <li v-if="!(!isEdit || !(checkProperty(selectedItem ,'jiraId')!=false ||
                 checkProperty(selectedItem ,'jiraId') !='' ))"><vs-chip :name="'fileRemoveSelected'" 
                  v-for="(other, indx) in ticket.documents" :key="indx"> {{ other.name }} 
                  <span @click="download_file(other)" class="material-icons download">get_app</span>
                  </vs-chip></li>
                </ul> 
              </div>
            </li> 
          </ul>
        </form>
        <!-- <div  v-if="importData">
          <form @submit.prevent>
           <file-upload v-model="fileDoc" class="file-upload-input"
                      accept=""  :name="'files'" data-vv-as="Upload SDK files"
                        @change="uploadFile()" >
                        <img class="file-icon" src="@/assets/images/file-icons/file-upload.svg"> Upload
                      </file-upload>
          </form>
        </div> -->
        <div class="form_actions pad0">
           <!--<vs-upload multiple  automatic action="https://jsonplaceholder.typicode.com/posts/" />-->
           <span></span>
           
          <button  v-if="!isEdit" class="close_popup primary_btn" :disabled="validateForm" @click="onSubmit()">Create</button>
          <button  v-if="isEdit" class="close_popup primary_btn" :disabled="validateForm" @click="updateTicket()">Update</button>
        
        
        </div>
      </div>
      
    </vs-popup>
     <!-- <div  v-if="importData">
          <form @submit.prevent>
           <file-upload v-model="fileDoc" class="file-upload-input"
                      accept=""  :name="'files'" data-vv-as="Upload SDK files"
                        @change="uploadFile()" >
                        <img class="file-icon" src="@/assets/images/file-icons/file-upload.svg"> Upload
                      </file-upload>
          </form>
        </div> -->

     <vs-popup class="holamundo" :active.sync="popupCreateProject"  title="New Project">
      <div class="createticket_form form_section">
        <form autocomplete="off">
          <ul>
            <li>
              <div class="form-group">
                <label class="form_label">Name*</label>
                <vs-input
                  v-validate="'required'"
                 
                  name="Name"
                  icon-no-border
                  icon-pack="feather"
                  v-model="projectName"
                  class="w-full"
                />
                <span class="text-danger text-sm">{{
                  errors.first("Name")
                }}</span>
              </div>
            </li>
          </ul>
        </form>
        <div class="form_actions">
           <!--<vs-upload multiple  automatic action="https://jsonplaceholder.typicode.com/posts/" />-->
           <span></span>
          <button class="close_popup primary_btn" 
          :disabled="!validateProject"
          @click="onAddProject()">Create</button>
        </div>
      </div>
      
    </vs-popup>

    <vs-popup
        class="holamundo"
        :active.sync="popupAssignFlag"
        title="Manage case assignments"
      >
        <div class="createticket_form">
          <form autocomplete="off">
          <ul>
            <li>
              <div class="form-group">
              
                <label class="form_label">Assign To</label>
                <multiselect
                  v-model="assignedTo" 
                  :options="employeeList"
                  :close-on-select="true"
                  :clear-on-select="false"
                  :hide-selected="false" 
                  :preserve-search="true"
                  placeholder="Select "
                  label="name"
                  track-by="name"
                  :preselect-first="false"
                  id="assign"
                  :multiple="false"
                >
                  <template slot="selection" slot-scope="{ values, isOpen }">
                    <span
                    
                      class="multiselect__selectcustom"
                      v-if="values.length && !isOpen"
                      >{{ values.length }} Employee(s) selected</span
                    >
                    <span
                      class="multiselect__selectcustom"
                      v-if="values.length && isOpen"
                    ></span>
                  </template>
                  <span slot="noResult">No Employees Found</span>
                </multiselect>
              </div>
            </li>
          </ul>
        </form>
          <div class="form_actions">
            <span></span>
            <!----:disabled="!validateAssign"--->
            <button class="close_popup primary_btn" 
              
              @click="onAssignEmployee()">
              Update
            
            </button>
          </div>
        </div>
   </vs-popup>


      <vs-popup
      class="holamundo"
      :active.sync="addTojiraPopup"
      :title="'Approve'"
    >
      <div class="createticket_form alert_popup alert_messages">
        
       
        <p>
          Are you sure want to Add to jira ?
        </p>
        <div class="form_actions">
          <span class="secondary_btn" @click="addTojiraPopup=false;submitedJira=false">No</span>
         
          <button :disabled="submitedJira" class="close_popup primary_btn marl15" @click="transforToJira(transforToJiraItem)">
            Yes
          </button>
        </div>
      </div>
    </vs-popup>


  </div>
</template>

<script>
import vSelect from 'vue-select'
import DateRangePicker from 'vue2-daterange-picker'
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
import FileUpload from "vue-upload-component/src";
import Multiselect from 'vue-multiselect-inv';
import moment from "moment";

import _ from "lodash";
import Vue from 'vue';
import CKEditor from '@ckeditor/ckeditor5-vue2';
Vue.use( CKEditor );
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import axios from '@/axios.js'

export default {
  components: { 
    //ClassicEditor,
    //CKEditor,
    vSelect,
    DateRangePicker,
    
    FileUpload,
    Multiselect
  },
   computed: {
     getAactiveCustomer() {
     
      if(_.has(this.$store.state.auth , 'ViewAsCustomer')){
         return this.$store.state.auth.ViewAsCustomer
      }else if(localStorage.getItem('ViewAsCustomer')){
        return  JSON.parse(localStorage.getItem('ViewAsCustomer'));
      }else{
        return null;
      }
     
    },
     
    validateForm() {

/*
selectedProject
      let regex = /(<([^>]+)>)/ig ;
     let result = this.ticket.description.replace(regex, "");
     let replaced = result.split(' ').join('');
     if(this.activeUserInfo.roleId==1 && this.assignedTo != null){
                 

        }else{
           return false
        }
     */
      if (
        !this.errors.any() &&
        this.ticket.description !== "" &&  this.ticket.title !== "" 
        //&& this.ticket.selectedProject !== null 
        && this.ticket.priorityId != ""
        && this.ticket.typeId !=''
        
      ){
        if( this.activeUserInfo.roleId==1 && !this.isEdit ){

          if(this.assignedTo != null && this.ticket.selectedProject !=null ){
            return false;
          }else{
            return true;
          }

        }else{
           return false
        }
       
      }else{
        return true;
      }
    },
    activeUserInfo () {
      return this.$store.state.auth.user
    },
     validateProject() {
      return (
        !this.errors.any() &&
        this.projectName !== ""
      );
    },
    validateAssign() {
     // return this.assignedTo > 0
      return this.assignedTo != null
    },
  },
  data:() => ({
    users:{
      filePath:''
    },
    exportPath:'',
    isExport:false,
    acceptedFiles :'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel',
    //importData: false,
    emptyCompanytickets:[],
    ticketcompanyUpdatedPriviously:false,
    loading:false,
     companyUsersList:[],
    filtersList: false,        
    device_family:[],
    deviceFamDetails:null,

    ticket_priority:[],
    priorityDetails:null,

    ticket_type:[],
    ticketTypeDetails:null,

    versions:[],
    versionDetails: null,

    Areas:[],
    areaDetails:null,

    addTojiraPopup:false,
    transforToJiraItem:null,
    callFromSort:false,
    companies:[],
     customerList:[],
     searchCustomer:'',
     maxDate: new Date(),
    editor: ClassicEditor,
    editorConfig: {
        // The configuration of the editor.
         toolbar: [ 'bold', 'italic', '|', 'undo','redo' ,"indent" ,"Outdent" ,'NumberedList', 'BulletedList', ],
        
    },

    userdata:null,
    reportTo_obj:'',
    products: [],
    list: [],
    projects: [],
    companyProjects:[],
   // ticket: {"description":'',"title":'',"selectedProject":''},
   ticket: {
     selectedProject:null,
     title:'',
     selectedCompany:null,
   },
    sortKey: {createdOn:-1},
    page: 1,
    perPage: 25,
    totalPages: 0,
    sortKeys: {
      customId: 1,
      title:1,
      statusName: 1,
      createdOn: -1,
      createdByName: 1,
      projectName: 1,
      updatedOn: 1
    },
    documents:[],
    fileDoc:[],
    status_list: [],
    selected_createdDateRange :{
      startDate: null,
      endDate: null
    },
    perPeges: [25, 50, 75, 100],
    stats : {
      1: 0,
      2: 0,
      3: 0,
      4: 0,
      5: 0,
      6:0,
      7:0
    },
    autoApply: "",
    config: {
        events: {
          initialized: function () {
            console.log('initialized')
          }          
        },
        charCounterCount: false,
        //toolbarButtons: ['undo', 'redo' , '|', 'bold', 'italic', 'underline', 'strikeThrough', 'subscript', 'superscript', 'outdent', 'indent', 'clearFormatting', 'insertTable', 'html'],
        toolbarButtons: ['undo', 'redo' , '|', 'bold', 'italic', 'underline'],
        //toolbarButtonsXS: ['undo', 'redo' , '-', 'bold', 'italic', 'underline']
      },
      model: 'Edit Your Content Here!',
    filterData: {
      title: "",
      statusIds: [],
      productIds: [],
      productIds: [],
      projectIds: [],
      customerIds: [],
      createdOnRange: [],
      companyIds:[],
      
      priorityDetails: [],
      typeDetails: [],
      areaDetails: [],
      deviceFamDetails: [],
      versionDetails: [],
      sharedToIdDetails:[],

    },

    userFilters: {
      title: "",
      statusIds: [],
      productIds: [],
      customerIds: [],
      projectIds: [],
      createdOnRange: [],
       companyIds:[],
    },
    projectName: '',
    popupCreateProject: false,
    assignedTo: null, //[],
    employeeList: [],
    popupAssignFlag: false,
    ticketId: "",

    reportinglist: [
      { label: 'Internal Project', value: 'internal' },
      { label: 'Customer Project', value: 'customer' } 
    ],
    textarea: '',
    popupcreateticket:false,
    dateRange:'',
    statusFilter: { label: 'All', value: 'all' },
    statusOptions: [
      { label: 'All', value: 'all' },
      { label: 'New', value: 'new' },
      { label: 'In Progress', value: 'inProgress' },
      { label: 'Rejected', value: 'rejected' },
      { label: 'Defered', value: 'defered' },
      { label: 'Closed', value: 'closed' }
    ],
    emailFilter: { label: 'All', value: 'all' },
    emailOptions: [
      { label: 'All', value: 'all' },
      { label: 'user@yopmail.com', value: 'user' },
      { label: 'admin@yopmail.com', value: 'admin' } 
    ],
      
    direction: 'ltr',
    format: 'mm/dd/yyyy',
    separator: ' - ',
    applyLabel: 'Apply',
    cancelLabel: 'Cancel',
    weekLabel: 'W',
    customRangeLabel: 'Custom Range',
    daysOfWeek: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
    monthNames: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
    firstDay: 0,

    searchQuery: '',
    transforToItem:null,
    jiraResponse:null,
    submitedJira:false,
    isEdit:false,
    selectedItem:null,
    usersIdDetails:[]


    ////////////
     
  }),
  methods:{

    changedAssignTo(){
      if(this.activeUserInfo.roleId == 1){
        this.ticket = Object.assign(this.ticket ,{"assignedTo":[]});
       if( this.assignedTo != null && _.has(this.assignedTo ,"_id")){
            this.ticket['assignedTo'] =[ this.assignedTo['_id']] 
       }


      }
      

    },

viewAsCustomer(customer){
      this.$store.dispatch("auth/viewAsCustomer", customer)
      .then((res)=>{
        if(this.$store.state.auth.user.settings){

            if(this.$store.state.auth.user.settings.indexOf(1) >-1 || (this.$store.state.auth.user.settings.indexOf(2) >-1)){
              this.$router.push({ path: '/SDK', query: { } });
            }else if(this.$store.state.auth.user.settings.indexOf(3) >-1){

              this.$router.push({ path: '/support-cases', query: { } });
  v
            }else if(this.$store.state.auth.user.settings.indexOf(4) >-1){
  
              this.$router.push({ path: '/knowledge', query: { } });
  
            }else{
                 this.$router.push({ path: '/support-cases', query: { } });
            }

          }else{
            this.$router.push({ path: '/support-cases', query: { } });
          }     
       // console.log('customer', customer)
       // this.$router.push("/support-tickets");
       
      })
      .catch((err)=>{

      });

    },

    goTojira(key=''){
      window.open("https://dvits.atlassian.net/browse/"+key ,"_blank")

    },
    projectChanged(){
       this.usersIdDetails =[];
       this.ticket.sharedTo= [];
       
       this.getComapnyUsers();
    },
      getComapnyUsers(val='') {
    
      let postData =  {
		"matcher": {
			"searchString":val,
		//	"cntryId": 101,
		//	"stateId": 665,
		//	"cntryIds": [38], // Requied for "state" 
		//	"stateIds": [665], // Requied for "city"
		//	"roleIds": [5], // Required for "reporting_to"
    //		"getCompanyUsers": true, // Required for only user_list
		///	"timesheetApprovalUsers": true, // Required for only user_list
  		//"projectId": 2 // Required for only share_ticket_users
		},
		"page": 1,
		"perpage": 1000000,
		"category": "share_ticket_users", // share_project_users, share_ticket_users, ticket_priority, ticket_type, notes_tagged_to, notes_visible_to, notes_status, notes_category, timesheet_work_type, timesheet_status,document_status, folder_status, request_status, request_priority, client_list, task_status, user_list, reporting_to, user_status,user_role,company_status,client_status,industry,company_type,designation,country,state,department 
	}
      // alert(this.activeUserInfo.companyId);

     if(_.has(this.ticket ,'selectedProject' ) && this.ticket['selectedProject']){
       postData['matcher']['projectId'] = this.ticket['selectedProject']['_id'];

     }

     if(this.ticket.companyId){
       postData['matcher']['companyIds'] =[this.ticket.companyId];
     }
      
        
     
      this.companyUsersList = [];
      this.$store
        .dispatch("getMasterData", postData)
        .then((response) => {
          let customers = response.list;
          _.forEach(customers ,(item)=>{
              if(_.has(item ,"name") && _.has(item ,"email") ){
                item['name'] = item['name'] +" ( "+item['email']+" )"
              }

             if(this.isEdit){
                if(_.has(this.selectedItem ,"owners") && this.selectedItem.length>0 ){
                    if( _.includes(this.selectedItem['owners'] , item['_id']) <=-1){
                        this.companyUsersList.push(item);
                    }
                }else{
                  this.companyUsersList.push(item);

                }

              }else{
                  this.companyUsersList.push(item);
              }
             

            
           

          });
         
          //this.totalpages = Math.ceil(response.totalCount / this.perPage);
        })
        .catch((err) => {
          console.log(err);
         // this.loaded = true;
        });
    },
     download_file(value) {
      if(_.has(value , "path")){
        value['url'] = value['path'];
      }
    /*
      value.url = value.url.replace(
        "https://lnaccounting.s3.ap-south-1.amazonaws.com/",
        ""
      );
      */
      // let postdata = { keyName: value.path , "taskId": this.taskDetails['_id']};
      let postdata = { keyName: value.url };

      this.$store.dispatch("getSignedUrl", postdata).then((response) => {
        
        window.open(response.data.result.data, "_blank");
         //window.location.href = response.data.result.data;
      });
    },
    updateTicket() {

      if( (_.has(this.ticket , "selectedProject"))  && ( _.has(this.ticket.selectedProject , "_id")) ){
          this.ticket.projectId = this.ticket.selectedProject['_id'];
      }

      //usersIdDetails usersIds
      if(this.usersIdDetails.length>0){
        this.ticket.sharedTo = [];
        _.forEach(this.usersIdDetails , (user)=>{
           
           this.ticket.sharedTo.push(user['_id']);

        });
      }

      this.$vs.loading();
     
      this.$store
        .dispatch("supportTicketUpdate", this.ticket)
        .then((res) => {
          this.popupcreateticket = false;
          // this.updateUserKey();
          this.$vs.loading.close();
          this.getList();
          this.getDashboardStats();
          
         
          this.$vs.notify({
            title: "Success",
            text: res.message,
            iconPack: "feather",
            icon: "icon-alert-circle",
            position: "top-right",
            color: "success",
          });
          
          setTimeout(()=>{
             this.errors.clear();
             this.init();
          },1000)
          
          
        })
        .catch((error) => {
          this.$vs.loading.close();
           this.errors.clear();
          this.$vs.notify({
            title: "Error",
            text: error.message,
            position: "top-right",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
          });
        });
    },
    editMe(item){
      this.isEdit =true;
      this.filtersList =false;
      this.init();

      const payload = {
          ticketId: item['_id'],
      };
      this.$store
      .dispatch("getTicketDetails", payload)
      .then((res) => {
          this.selectedItem = res;

          this.ticket = {
          
          ticketId: item['_id'],
          title: this.selectedItem['title'],
          description: this.selectedItem['description'],
          selectedProject:this.selectedItem['projectDetails']?this.selectedItem['projectDetails']:null,
          projectId: this.selectedItem['projectId'],
          documents: this.selectedItem['documents'],
          today: moment().format("YYYY-MM-DD"),
          jiraId:this.selectedItem['jiraId']?this.selectedItem['jiraId']:'',
          
          deviceFamId:this.selectedItem['deviceFamId']?this.selectedItem['deviceFamId']:'',
          areaId:this.selectedItem['areaId']?this.selectedItem['areaId']:'',
          version:this.selectedItem['version']?this.selectedItem['version']:'',
          priorityId:this.selectedItem['priorityId']?this.selectedItem['priorityId']:'',
          typeId:this.selectedItem['typeId']?this.selectedItem['typeId']:'',
          sharedTo:[],
          selectedCompany:null

      };

      if(_.has( this.selectedItem ,"createdByDetails")){
        if(_.has(this.selectedItem['createdByDetails'] , "companyDetails")){
         // alert(JSON.stringify(this.companies));
          this.ticket.selectedCompany = this.selectedItem['createdByDetails']["companyDetails"];
        }

      }

      //changedDevice  changedArea changedVersion changedPriority changedType
      if(this.checkProperty(this.selectedItem ,'priorityDetails')){
        this.priorityDetails = this.selectedItem['priorityDetails'];
        this.changedPriority(this.selectedItem['priorityDetails']);

      }

       if(this.checkProperty(this.selectedItem ,'deviceFamilyDetails')){
        this.deviceFamDetails = this.selectedItem['deviceFamilyDetails'];
        this.changedDevice(this.selectedItem['deviceFamilyDetails']);

      }
      if(this.checkProperty(this.selectedItem ,'typeDetails')){
        this.ticketTypeDetails = this.selectedItem['typeDetails'];
        this.changedType(this.selectedItem['typeDetails']);

      }

      if(this.checkProperty(this.selectedItem ,'versionDetails')){
        this.versionDetails = {"_id":this.selectedItem['versionDetails']['_id'],"name":this.selectedItem['versionDetails']['version'] };
        
        this.changedVersion(this.versionDetails);

      }
       if(this.checkProperty(this.selectedItem ,'areaDetails')){
        this.areaDetails = this.selectedItem['areaDetails'];
        this.changedArea(this.selectedItem['areaDetails']);

      }

//companies

if( _.has(this.selectedItem,'createdByDetails') && _.has(this.selectedItem['createdByDetails'],'companyDetails')  ){
  this.ticket.selectedCompany = this.selectedItem['createdByDetails']['companyDetails']
}else if( _.has(this.selectedItem,'companyDetails')   ){
  
  this.ticket.selectedCompany = this.selectedItem['companyDetails']
}
       //sharedTo
      if(_.has(this.selectedItem ,"sharedToDetails") && ( this.selectedItem['sharedToDetails'].length>0)){
        this.usersIdDetails = [];

        _.forEach(this.selectedItem['sharedToDetails'] ,(userObj)=>{
           this.ticket.sharedTo.push(userObj['_id']);
          let user =  _.find(this.companyUsersList ,{"_id":userObj['_id']});
          if(user){
            this.usersIdDetails.push(user);

          }



        });
        //alert(JSON.stringify(this.companyUsersList));

      }
      this.errors.clear();

/*
      deviceFamDetails:null,
    priorityDetails:null,
    ticketTypeDetails:null,
    versionDetails: null,
    areaDetails:null,
    */
          
      })
      .catch((error) => {
        console.log(error)
      });
     
      
     // this.ticket = item;
      this.errors.clear();
      this.popupcreateticket = true;

    },

    checkProperty(obj ,key='' ,subKye=''){
      
      if(_.has(obj , key)){
         //alert(key+" ---"+subKye)
        if(obj[key]){
          if(subKye==''){
            return obj[key];
          }else{

            if(_.has(obj[key] , subKye)){
              if(obj[key][subKye]){
                 return obj[key][subKye];
              }else{
                 return false;
              }

            }else{
              return false;
            }
          }
          
        }else{
          return false;
        }
     

      }else{
        return false;
      }

    }, 
    getAreas(){
      let postData ={
        page: 1,
        perpage: 10000000,
        category: 'area'
      }
      this.$store.dispatch("getAreas" ,postData).then((response) => {
      this.Areas = _.filter(response, (obj)=> {
        return obj._id != 2;
      });
    });

    },
    changedArea(item){
      this.ticket.areaId ='';
      if(item !=null){
        this.ticket.areaId =item._id;
      }
      
    },
    changedDevice(item){
      this.ticket.deviceFamId  ='';
      if(item !=null){
        this.ticket.deviceFamId =item._id;
      }
      
    },

    changedType(item){
      this.ticket.typeId  ='';
      if(item !=null){
        this.ticket.typeId =item._id;
      }
      
    },

    changedPriority(item){
      this.ticket.priorityId  ='';
      if(item !=null){
        this.ticket.priorityId =item._id;
      }
      
    },

    getMasterData(category ="device_family"){
      let postData ={
        page: 1,
        perpage: 10000000,
        category: category
      }
      this.$store.dispatch("getDeviceFamily" ,postData).then((response) => {
      this[category] = response;
     
    });

    },
    changedVersion(item){
      this.ticket.version ='';
      if(item !=null){
        this.ticket.version =item._id;
      }
     
    },
    getVersions(){
      let postData = {
      "filters":{ "title": ""},		
        "page": 1,
        "perpage": 1000000000
      }
      this.$store
        .dispatch("getSdkVersionsList", postData)
        .then((response) => {
          this.versions = response.list;
          
         
        })
        .catch((err) => {
          console.log(err);
          
          
        });
    },
    openAddtogira(item){
      this.transforToJiraItem = item;
      this.addTojiraPopup = true;
      this.submitedJira =false;
    },
    transforToJira(item){
      //this.$route.path
      this.submitedJira =true;
    let  url = window.location.origin+this.$route.path //"/support-ticket-details/"+item['_id']
    
      this.transforToItem =item;
      let payload =  { "ticketId": this.transforToItem['_id'],"redirectUrl": url
      }
      this.$store
        .dispatch("transforToJira", payload)
        .then((response) => {
         
          this.$vs.notify({
            title: "Success",
            text: response['message'],
            iconPack: "feather",
            icon: "icon-alert-circle",
            position: "top-right",
            color: "success",
          });
         this.addTojiraPopup =false;
         this.submitedJira =false;
         this.getList();
          
          
        })
        .catch((err) => {
         
          if(_.has(err ,"error_message") && _.has(err['error_message'] ,'code') ){
            //alert(err['error_message']['message']);//JIRA_AUTH_REQUIRED
            if(err['error_message']['code'] == "JIRA_AUTH_REQUIRED"){
              window.location = err['error_message']['authUrl'];

            }

          }else{
             this.submitedJira =false;
            this.$vs.notify({
            title: "Error",
            text: err['error_message']['message'],
            iconPack: "feather",
            icon: "icon-alert-circle",
            position: "top-right",
            color: "danger",
          });
          }
         
        });
       

    }, 

    getDescription(sdk){
      let hrml  = sdk.description;
      let str = hrml.replace(/<[^>]*>/g, '');
      return str.substring(0, 15);
    },

    // @search-change="searchCustomerList"
    searchCustomerList(val=''){
      this.searchCustomer = val;
      this.getCustomerList();
    },
    getCustomerList() {
      let postData = {"filters":{"title":this.searchCustomer,"roleIds":[2],"statusIds":[],"createdOnRange":[] ,"companyIds":[]},"sorting":{"path":"createdOn","order":1},"page":1,"perpage":25};
     
     
     if(this.filterData.companyIds && this.filterData.companyIds.length>0 && this.activeUserInfo.roleId != 2){
         _.forEach(this.filterData.companyIds  ,(obj)=>{
             postData['filters']['companyIds'].push(obj['_id']);
         });
     }


     if(this.activeUserInfo.roleId ==2 && this.activeUserInfo.companyId){
         postData['filters']['companyIds'] =[];
         postData['filters']['companyIds'].push(this.activeUserInfo.companyId);
      

     }

     this.getCompanyProjects(false);
     
     //filterData.customerIds
      this.customerList = [];
      this.$store
        .dispatch("auth/get_users_list", postData)
        .then((response) => {
          //this.customerList = response.list;
          let dt  = response.list;
          if(dt.length>0){
            _.forEach(dt ,(obj)=>{
              let cus = obj;
              if(_.has(obj ,"companyDetails")){
                cus['name'] =  cus['name']+" ("+obj['companyDetails']['name']+")"
              }
              this.customerList.push(cus);



            });

          }
          //this.totalpages = Math.ceil(response.totalCount / this.perPage);
        })
        .catch((err) => {
          console.log(err);
          this.loaded = true;
        });
    },
    gotopage () {
      alert('test')
    },
    addProject (newTag) {
      this.reportinglist.push( 
        { 'label':newTag, 'value':newTag} 
      )
    },
     change_perPage() {
      this.page = 1;
      this.getList();
    },
    updateSearchQuery (val) {
      this.gridApi.setQuickFilter(val)
    },
     setColumnFilter (column, val) {
      const filter = this.gridApi.getFilterInstance(column)
      let modelObj = null

      if (val !== 'all') {
        modelObj = { type: 'equals', filter: val }
      }

      filter.setModel(modelObj)
      this.gridApi.onFilterChanged()
    },
    resetColFilters () {
      // Reset Grid Filter
      this.gridApi.setFilterModel(null)
      this.gridApi.onFilterChanged()

      // Reset Filter Options
      this.roleFilter = this.statusFilter = this.isVerifiedFilter = this.departmentFilter = { label: 'All', value: 'all' }

      this.$refs.filterCard.removeRefreshAnimation()
    },
    openCreatePop() {
      this.assignedTo = null;
      this.ticket.selectedProject =null;
      this.isEdit =false;
      setTimeout(()=>{ 
        this.errors.clear();
      },10);
      this.init();
      this.popupcreateticket = true;
     
     // this.updateUserKey();
    },
    // opencreateimport(){
    //   this.importData=true
    // },
    
    openProjectPop() {
      this.projectName = ""
      this.errors.clear();
      this.popupCreateProject = true;
    },
     init() {
        this.filtersList =false;
        this.usersIdDetails = [];
      this.ticket = {
        selectedCompany:null,

        sharedTo:[],
        description: "",
        title: "",
        selectedProject:null,
        productId: "",
        documents: [],
        projectId: "",
        today: moment().format("YYYY-MM-DD"),
        deviceFamId:'',
        areaId:'',
        version:'',
        priorityId:"",
        typeId:''
      };

      if(_.has(this.userdata , 'companyId') && this.userdata['companyId'] ){
     this.ticket['companyId'] =this.userdata['companyId'];
     this.ticket = Object.assign(this.ticket ,{"companyId":this.userdata['companyId']}) 

   }

    if(this.ticket['companyId'] && this.companies){
      this.ticket.selectedCompany = _.find(this.companies , {"_id":this.ticket['companyId']})

    }

    
    this.deviceFamDetails = null;
    this.priorityDetails = null;
    this.ticketTypeDetails = null;

    this.versionDetails =  null;
    this.areaDetails = null;
    },
    getList() {
      let postData = {
      //  filters: {
      //     title: this.userFilters.title,
      //     projectIds: this.userFilters.projectIds, //[4, 5],
      //     productIds: this.userFilters.productIds, //[4, 5],
      //     statusIds: this.userFilters.statusIds,
      //     customerIds:this.userFilters.customerIds,
      //     companyIds:this.userFilters.companyIds,
      //     createdOnRange:[],
      //   },
           filters:{"title": this.filterData.title,	"projectIds": [],	
           "productIds": [],
           	"statusIds": [] ,	
            "customerIds": [],
            "companyIds": [] ,
            "createdOnRange":[],

            "priorityIds": [],
            "typeIds": [],
            "areaIds": [],
            "deviceFamIds": [],
            "versionIds": [],
            "sharedToIds":[]

           },
        sorting: this.sortKey, //{"path": "name","order": -1	},
        page: this.page,
        perpage: this.perPage,
      };
      //  if(_.has(this.selected_createdDateRange ,'startDate' ) && this.selected_createdDateRange.startDate != null && this.selected_createdDateRange.endDate != null && _.has(this.selected_createdDateRange ,'endDate' )){
      //   postData.filters['createdOnRange'].push(moment(this.selected_createdDateRange['startDate']).format("YYYY-MM-DD"));
      //   postData.filters['createdOnRange'].push(moment(this.selected_createdDateRange['endDate']).format("YYYY-MM-DD"));
      // }
       if(this.filterData.projectIds.length>0){
        for( let i=0; i<this.filterData.projectIds.length;i++){
          postData.filters.projectIds.push(this.filterData.projectIds[i]['_id'] )
        }
      }
       if(this.filterData.customerIds.length>0){
        for( let i=0; i<this.filterData.customerIds.length;i++){
          postData.filters.customerIds.push(this.filterData.customerIds[i]['_id'] )
        }
      }
       if(this.filterData.companyIds.length>0){
        for( let i=0; i<this.filterData.companyIds.length;i++){
          postData.filters.companyIds.push(this.filterData.companyIds[i]['_id'] )
        }
      }
      if(this.filterData.productIds.length>0){
        for( let i=0; i<this.filterData.productIds.length;i++){
          postData.filters.productIds.push(this.filterData.productIds[i]['_id'] )
        }
      }
      if(this.filterData.statusIds.length>0){
        for( let i=0; i<this.filterData.statusIds.length;i++){
          postData.filters.statusIds.push(this.filterData.statusIds[i]['_id'] )
        }
      }
     if(this.filterData.priorityDetails.length>0){
        for( let i=0; i<this.filterData.priorityDetails.length;i++){
          postData.filters.priorityIds.push(this.filterData.priorityDetails[i]['_id'] )
        }
      }
     if(this.filterData.typeDetails.length>0){
        for( let i=0; i<this.filterData.typeDetails.length;i++){
          postData.filters.typeIds.push(this.filterData.typeDetails[i]['_id'] )
        }
      }  
    if(this.filterData.areaDetails.length>0){
        for( let i=0; i<this.filterData.areaDetails.length;i++){
          postData.filters.areaIds.push(this.filterData.areaDetails[i]['_id'] )
        }
      }
      
    if(this.filterData.deviceFamDetails.length>0){
        for( let i=0; i<this.filterData.deviceFamDetails.length;i++){
          postData.filters.deviceFamIds.push(this.filterData.deviceFamDetails[i]['_id'] )
        }
      }
    if(this.filterData.versionDetails.length>0){
        for( let i=0; i<this.filterData.versionDetails.length;i++){
          postData.filters.versionIds.push(this.filterData.versionDetails[i]['_id'] )
        }
      }   

      if(_.has(this.selected_createdDateRange ,'startDate' ) && this.selected_createdDateRange.startDate != null && this.selected_createdDateRange.endDate != null && _.has(this.selected_createdDateRange ,'endDate' )){
        postData.filters['createdOnRange'].push(moment(this.selected_createdDateRange['startDate']).format("YYYY-MM-DD"));
        postData.filters['createdOnRange'].push(moment(this.selected_createdDateRange['endDate']).format("YYYY-MM-DD"));
      }

      //sharedToIdDetails

      if(this.filterData.sharedToIdDetails.length>0){
        for( let i=0; i<this.filterData.sharedToIdDetails.length;i++){
          postData.filters.sharedToIds.push(this.filterData.sharedToIdDetails[i]['_id'] )
        }
      }

     
     
      if(!this.callFromSort){
         this.list = [];
         this.$vs.loading()
      }
      this.callFromSort =false;
     this.loading =true;
     this.emptyCompanytickets = [];
      
      this.$store
        .dispatch("getTicketList", postData)
        .then((response) => {
          this.list = response.list;
          this.totalPages = Math.ceil(response.totalCount / this.perPage);
            this.list.forEach((item) => {
            if (item.assignEmpDetails && item.assignEmpDetails.length > 0) {
              let arr = [];
              item.assignEmpDetails.forEach((item2) => {
                if (item2.name) {
                   arr = item2.name.split(" ");
                  if (arr.length > 1) {
                    item2.shortName = arr[0].charAt(0).concat(arr[1].charAt(0));
                  } else if (arr.length == 1) {
                    item2.shortName = arr[0].slice(0, 2);
                  }
                }
               
              });
            }
            //check support ticket bind with company . if not bind with any company . update support ticket
           
              if(_.has(item, "createdByDetails")){
                if(!(_.has(item['createdByDetails'] ,"companyDetails"))){
                  this.emptyCompanytickets.push(item['_id']);

                }

                }

          });
          this.loading =false;
          this.$vs.loading.close();

          if(  (this.emptyCompanytickets.length>0 && !this.ticketcompanyUpdatedPriviously)){
            this.updateTicketwithDefaultCompany();

          }

        })
        .catch((err) => {
          this.loading =false;
            this.$vs.loading.close();
          console.log(err);
        });
    },
    exportList() {
     // alert('export')
      let APIURL = axios.defaults['baseURL'];
      let postData = {
      //  filters: {
      //     title: this.userFilters.title,
      //     projectIds: this.userFilters.projectIds, //[4, 5],
      //     productIds: this.userFilters.productIds, //[4, 5],
      //     statusIds: this.userFilters.statusIds,
      //     customerIds:this.userFilters.customerIds,
      //     companyIds:this.userFilters.companyIds,
      //     createdOnRange:[],
      //   },
           filters:{"title": this.filterData.title,	"projectIds": [],	
           "productIds": [],
           	"statusIds": [] ,	
            "customerIds": [],
            "companyIds": [] ,
            "createdOnRange":[],

            "priorityIds": [],
            "typeIds": [],
            "areaIds": [],
            "deviceFamIds": [],
            "versionIds": [],
            "sharedToIds":[]

           },
        sorting: this.sortKey, //{"path": "name","order": -1	},
        page: this.page,
        perpage: this.perPage,
      };
      //  if(_.has(this.selected_createdDateRange ,'startDate' ) && this.selected_createdDateRange.startDate != null && this.selected_createdDateRange.endDate != null && _.has(this.selected_createdDateRange ,'endDate' )){
      //   postData.filters['createdOnRange'].push(moment(this.selected_createdDateRange['startDate']).format("YYYY-MM-DD"));
      //   postData.filters['createdOnRange'].push(moment(this.selected_createdDateRange['endDate']).format("YYYY-MM-DD"));
      // }
       if(this.filterData.projectIds.length>0){
        for( let i=0; i<this.filterData.projectIds.length;i++){
          postData.filters.projectIds.push(this.filterData.projectIds[i]['_id'] )
        }
      }
       if(this.filterData.customerIds.length>0){
        for( let i=0; i<this.filterData.customerIds.length;i++){
          postData.filters.customerIds.push(this.filterData.customerIds[i]['_id'] )
        }
      }
       if(this.filterData.companyIds.length>0){
        for( let i=0; i<this.filterData.companyIds.length;i++){
          postData.filters.companyIds.push(this.filterData.companyIds[i]['_id'] )
        }
      }
      if(this.filterData.productIds.length>0){
        for( let i=0; i<this.filterData.productIds.length;i++){
          postData.filters.productIds.push(this.filterData.productIds[i]['_id'] )
        }
      }
      if(this.filterData.statusIds.length>0){
        for( let i=0; i<this.filterData.statusIds.length;i++){
          postData.filters.statusIds.push(this.filterData.statusIds[i]['_id'] )
        }
      }
     if(this.filterData.priorityDetails.length>0){
        for( let i=0; i<this.filterData.priorityDetails.length;i++){
          postData.filters.priorityIds.push(this.filterData.priorityDetails[i]['_id'] )
        }
      }
     if(this.filterData.typeDetails.length>0){
        for( let i=0; i<this.filterData.typeDetails.length;i++){
          postData.filters.typeIds.push(this.filterData.typeDetails[i]['_id'] )
        }
      }  
    if(this.filterData.areaDetails.length>0){
        for( let i=0; i<this.filterData.areaDetails.length;i++){
          postData.filters.areaIds.push(this.filterData.areaDetails[i]['_id'] )
        }
      }
      
    if(this.filterData.deviceFamDetails.length>0){
        for( let i=0; i<this.filterData.deviceFamDetails.length;i++){
          postData.filters.deviceFamIds.push(this.filterData.deviceFamDetails[i]['_id'] )
        }
      }
    if(this.filterData.versionDetails.length>0){
        for( let i=0; i<this.filterData.versionDetails.length;i++){
          postData.filters.versionIds.push(this.filterData.versionDetails[i]['_id'] )
        }
      }   

      if(_.has(this.selected_createdDateRange ,'startDate' ) && this.selected_createdDateRange.startDate != null && this.selected_createdDateRange.endDate != null && _.has(this.selected_createdDateRange ,'endDate' )){
        postData.filters['createdOnRange'].push(moment(this.selected_createdDateRange['startDate']).format("YYYY-MM-DD"));
        postData.filters['createdOnRange'].push(moment(this.selected_createdDateRange['endDate']).format("YYYY-MM-DD"));
      }

      //sharedToIdDetails

      if(this.filterData.sharedToIdDetails.length>0){
        for( let i=0; i<this.filterData.sharedToIdDetails.length;i++){
          postData.filters.sharedToIds.push(this.filterData.sharedToIdDetails[i]['_id'] )
        }
      }
      this.isExport = true
      this.$store
        .dispatch("exportTicketList", postData)
        .then((response) => {
        // alert('response')
           window.open(APIURL+"viewfile?path="+response.path, "_blank");
           this.isExport = false
         
          
        })
        .catch((err) => {
         
        });
    },
    updateTicketwithDefaultCompany(){
//alert(this.emptyCompanytickets.length)
       if( this.emptyCompanytickets.length>0 && !this.ticketcompanyUpdatedPriviously){
          let postData = {"supportTicketIds":this.emptyCompanytickets}
            this.$store.dispatch("updateTicketwithDefaultCompany",postData)
            .then((res)=>{
              this.emptyCompanytickets =[];
              this.ticketcompanyUpdatedPriviously =true;
              this.getList()

            })
            .catch(()=>{
              this.emptyCompanytickets =[];
              this.ticketcompanyUpdatedPriviously =true;

            });

          }

    },
    sortMe(sort_key = "") {
      
      this.sortKey = { path: "createdOn", order: -1 };
      if (sort_key != "") {
        this.sortKeys[sort_key] = this.sortKeys[sort_key] == 1 ? -1 : 1;
        this.sortKey = {};

        this.sortKey["path"] = sort_key;
        this.sortKey["order"] = this.sortKeys[sort_key] == 1 ? -1 : 1;
        this.callFromSort =true;
        //alert();
        this.getList();

      }
    },
    upload(model){
     
          let temp_count = 0;
          let formData = new FormData();                    
          let mapper = model.map(
              item =>
              (item = {
                  name: item.name,
                  file: item.file ? item.file : null,
                  path: item.url ? item.url : "",
                  url:item.url ? item.url : "",
                  extn: item.name.split('.').pop(),
                  mimetype: item.type ? item.type : item.mimetype,
                  
              })
          );
              if (mapper.length > 0) {
                this.$vs.loading();
              mapper.forEach((doc, index) => {
                  formData.append("files", doc.file);
                  formData.append("secureType", "private");
                  this.$store.dispatch("uploadS3File", formData).then(response => {
                      temp_count++;
                   
                      response.data.result.forEach(urlGenerated => {
                          if(_.has(urlGenerated ,"path") && !( _.has(urlGenerated ,"url"))){
                              urlGenerated['url'] = urlGenerated ['path'];
                              
                          }
                           if(_.has(urlGenerated ,"url") && !( _.has(urlGenerated ,"path")) ){
                              urlGenerated['path'] = urlGenerated ['url'];
                              
                          }
                          this.ticket.documents.push(urlGenerated)                       
                               
                          if (temp_count >= mapper.length) {
                               
                             this.documents=[];
                              this.$vs.loading.close();
                          }

                          doc.url = urlGenerated;
                          delete doc.file;
                          mapper[index] = doc;

                      });
                  });

              });
              model.splice(0, mapper.length, ...mapper);
          }
            
      
    },
    uploadLocalFile(model){
          let formData = new FormData();                    
          let mapper = model.map(
              item =>
              (item = {
                  name: item.name,
                  file: item.file ? item.file : null,
                  path: item.url ? item.url : "",
                  url:item.url ? item.url : "",
                  extn: item.name.split('.').pop(),
                  mimetype: item.type ? item.type : item.mimetype,
                  
              })
          );
            var ext = mapper[0].extn.split('.').pop();
              if (['xlsx', 'xlsm' ,'xml','xls','xltm','xlsb','xltx'].indexOf(ext.toLowerCase()) > -1) {
                this.$vs.loading();
              mapper.forEach((doc) => {
                  formData.append("files", doc.file);
                  formData.append("secureType", "global");
                  this.$store.dispatch("uploadLocalFiless", formData).then(response => {
                     // temp_count++;                   
                      response.data.result.forEach(urlGenerated => {

                          if(_.has(urlGenerated ,"path") && !( _.has(urlGenerated ,"url"))){
                              urlGenerated['url'] = urlGenerated ['path'];
                              
                          }
                           if(_.has(urlGenerated ,"url") && !( _.has(urlGenerated ,"path")) ){
                              urlGenerated['path'] = urlGenerated ['url'];       
                          }
                         //  alert()
                          this.users.filePath = urlGenerated['path']
                          this.fileUploading()
                      });
                  });

              });
              model.splice(0, mapper.length, ...mapper);
          }else{
            this.$vs.notify({
            title: "Error",
            text: 'The selected file format is not supported',
            position: "top-right",
            iconPack: "feather",
            position: "top-right",
            icon: "icon-alert-circle",
            color: "danger",
          });
          this.$vs.loading.close();
          }      
    },
    fileUploading(){
      //alert('3')
      let responses=''
      this.$store.dispatch("uploadingFilesss",this.users).then((res)=>{
        console.log(res)
        responses=res.data.result.message
         this.$vs.notify({
            title:responses,
            text: res['message'],
            iconPack: "feather",
            icon: "icon-alert-circle",
            position: "top-right",
            color: "success",
          });
        this.$vs.loading.close();
        //alert('4')
      }).catch((error)=>{
        console.log(error)
      })
    },
    remove(index){
      this.ticket.documents.splice(index ,1);
    },
    onSubmit() {
      if( (_.has(this.ticket , "selectedProject"))  && ( _.has(this.ticket.selectedProject , "_id")) ){
          this.ticket.projectId = this.ticket.selectedProject['_id'];
      }
      //usersIdDetails usersIds
      if(this.usersIdDetails.length>0){
        this.ticket.sharedTo = [];

        _.forEach(this.usersIdDetails , (user)=>{
           
           this.ticket.sharedTo.push(user['_id']);

        });
      }

      
     // alert(JSON.stringify(this.ticket.sharedTo));

      this.$vs.loading();
      this.$store
        .dispatch("supportTicketCreate", this.ticket)
        .then((res) => {
          this.popupcreateticket = false;
          // this.updateUserKey();
          this.getList();
          this.getDashboardStats();
          this.$vs.loading.close();
         
          this.$vs.notify({
            title: "Success",
            text: res.message,
            iconPack: "feather",
            icon: "icon-alert-circle",
            position: "top-right",
            color: "success",
          });
           setTimeout(() => {
            this.init();
          }, 1000)
           
        })
        .catch((error) => {
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Error",
            text: error.message,
            position: "top-right",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
          });
        });
    },
    apply_filter(data) {
      this.filterData = data;
      this.page = 1;
      // this.userFilters = {
      //   title: data.title,
      //   statusIds: [],
      //   productIds: [],
      //   customerIds: [],
      //   projectIds: [],
      //   createdOnRange: [],
      //   companyIds:[],
      // };
      // if (this.filterData["productIds"].length > 0) {
      //   for (let i = 0; i < this.filterData["productIds"].length; i++) {
      //     this.userFilters["productIds"].push(
      //       this.filterData["productIds"][i]["_id"]
      //     );
      //   }
      // }

      // if (this.filterData["projectIds"].length > 0) {
      //   for (let i = 0; i < this.filterData["projectIds"].length; i++) {
      //     this.userFilters["projectIds"].push(
      //       this.filterData["projectIds"][i]["_id"]
      //     );
      //   }
      // }

      
      //  //customerList
      //   if (this.filterData["customerList"].length > 0) {
         
      //      this.userFilters["customerIds"] = [];
      //     for (let i = 0; i < this.filterData["customerList"].length; i++) {
      //       this.userFilters["customerIds"].push(this.filterData["customerList"][i]["_id"]);
      //     }
      //   }

      //   //companyIds
      //    if (this.filterData["companyIds"].length > 0) {
         
      //      this.userFilters["companyIds"] = [];
      //     for (let i = 0; i < this.filterData["companyIds"].length; i++) {
      //       this.userFilters["companyIds"].push(this.filterData["companyIds"][i]["_id"]);
      //     }
      //   }
      
    
      this.getList();
    },
    onAddProject() {
      const payload = {
        name: this.projectName,
      };
      payload.category = 'project'
      this.$vs.loading();
      this.$store
        .dispatch("projectCreate", payload)
        .then((res) => {
          this.popupCreateProject = false;
          this.projectName = "";
          this.getProjectList();
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Success",
            text: res.message,
            iconPack: "feather",
            icon: "icon-alert-circle",
            position: "top-right",
            color: "success",
          });
        })
        .catch((error) => {
            this.$vs.loading.close();
            this.$vs.notify({
              title: "Error",
              text: error.message,
              position: "top-right",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
            });
          });
    },
    getCompanyProjects(callfromNewTicke =false){
      this.companyProjects =[];
      let postData = {"matcher":{ "companyIds":[],"searchString":"","sharedToIds":[]},"page":1,"perpage":50000,"category":"project"};
      
       if(this.filterData.companyIds && this.filterData.companyIds.length>0 && !callfromNewTicke ){
         _.forEach(this.filterData.companyIds  ,(obj)=>{
             postData['matcher']['companyIds'].push(obj['_id']);
         });
        }else{
          postData['matcher']['companyIds'] = [];
          if(this.ticket.selectedCompany && callfromNewTicke ){

             postData['matcher']['companyIds'].push(this.ticket.selectedCompany['_id']);
             this.ticket['companyId']  =this.ticket.selectedCompany['_id'];
            

          }
        }
        
        //ticket.selectedCompany
      this.$store.dispatch("getMasterData" , postData).then((response) => {
        if(callfromNewTicke){
          this.projects = response['list'];
        }else{
          this.companyProjects = response['list'];
        }
         
         //alert(JSON.stringify(postData))

      })

    },
    getProjectList() {
        this.$store.dispatch("getProjects").then((response) => {
          let data = response;
           if (
      this.$route.params.projectId != undefined &&
      this.$route.params.projectId != null
    ) {

      let projedObj = null;
      _.forEach(data , (item)=>{
        if(item['_id'] ==this.$route.params.projectId ){
          projedObj = item;

        }

      });
         
      if(projedObj){
        this.filterData.projectIds.push(projedObj);

      }
      this.getList();
      
    }
        this.projects = data;
      });
    },
    openAssignPopup(item) {
      this.ticketId = item._id;
      this.assignedTo = null;//[]
        if (item.assignEmpDetails && item.assignEmpDetails.length > 0) {
            //this.assignedTo = item.assignEmpDetails;

          item.assignEmpDetails.forEach(obj => {
               if(obj ,"roleName"){
                   obj.name = obj.name + '('+obj.roleName +')'
               }
             
            })

            this.assignedTo = item.assignEmpDetails[0];
        } else {
          this.assignedTo = null //[]
        } 
      this.popupAssignFlag = true;
    },
    onAssignEmployee() {
      // this.assignedTo = this.assignedTo.map(item => item._id);
      let selectedAssignedTo =[] 
      if( this.assignedTo != null && _.has(this.assignedTo ,"_id")){
       selectedAssignedTo =[ this.assignedTo['_id']] 
      }

      
     
      
      const payload = {
        ticketId: this.ticketId,
        assignedTo: selectedAssignedTo //this.assignedTo
      };
     this.$vs.loading();
    this.$store
        .dispatch("assignEmployees", payload)
        .then((res) => {
          this.popupAssignFlag = false;
          this.getList()
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Success",
            text: res.message,
            iconPack: "feather",
            icon: "icon-alert-circle",
            position: "top-right",
            color: "success",
          });
        })
        .catch((error) => {
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Error",
            text: error.message,
            position: "top-right",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
          });
        });
      
     },
     getDashboardStats() {
      let postData = {};
      this.$store
        .dispatch("getTicketStats", postData)
        .then((response) => {
          _.forEach(response ,(object ,index) => {
            this.stats[object.statusId] = object.count;
         })
        })
        .catch((err) => {
          console.log(err);
        });
    },
    clearFilters() {
      this.filtersList =false;
       this.filterData = {
        title: "",
        statusIds: [],
        productIds: [],
        productIds: [],
        projectIds: [],
        createdOnRange: [],
        companyIds:[],
        customerIds: [],

      priorityDetails: [],
      typeDetails: [],
      areaDetails: [],
      deviceFamDetails: [],
      versionDetails: [],
      sharedToIdDetails:[],
      }
      this.selected_createdDateRange  = {
        startDate: null,
        endDate: null
      },
      this.getList();
    },
   transferToJiraCheck(item) {
      if(_.has(item , 'jiraId') && item['jiraId'] && _.has(item , 'jiraKey') && item['jiraKey'] ){
        return true;
      } else {
        return false;
      }
    },
    onEnter() {
      this.filtersList =false;
      this.getList();
    }
  },
  mounted() {
   
    this.userdata = this.$store.state.auth.user;
   // this.ticket['companyId']  =this.ticket.selectedCompany['_id'];
    //alert(JSON.stringify(this.userdata));
   if(_.has(this.userdata , 'companyId') && this.userdata['companyId'] ){
     this.ticket['companyId'] =this.userdata['companyId'];
     this.ticket = Object.assign(this.ticket ,{"companyId":this.userdata['companyId']}) 

   }

   
    this.getComapnyUsers();
    this.sortKey = { path: "createdOn", order: -1 };
    this.$store.dispatch("getProducts").then((response) => {
      this.products = response;
    });
    this.$store.dispatch("getTicketStatus").then((response) => {
      this.status_list = response;
    });
    this.$store.dispatch("getEmployeeList").then((response) => {
     
      this.employeeList = response;
      this.employeeList.forEach(item => {
        item.name = item.name + '('+item.roleName +')'
      })
      //this.employeeList = this.employeeList.map(item => item.name.concat(item.roleName))
    });
    this.$store.dispatch("getCompanies").then((response) => {
          this.companies = response;
     //alert(JSON.stringify(this.companies));
          if(this.ticket['companyId']){
            this.ticket.selectedCompany = _.find(this.companies , {"_id":this.ticket['companyId']})

          }
        });

    this.getProjectList();
    this.getCompanyProjects();
    this.getCustomerList();
    this.sortKeys = {
      customId: 1,
      statusName: 1,
      createdOn: -1,
      createdByName: 1,
      projectName: 1,
      updatedOn: 1
    };

    this.sortKey=  {createdOn:-1},
    this.getList();
    this.getDashboardStats();
    this.getVersions(); 
    
    this.getMasterData('device_family');
    this.getMasterData('ticket_priority');
    this.getMasterData('ticket_type');
    this.getAreas();
  },
  watch:{
    popupAssignFlag:(val)=>{
        let el = document.body;
        if (val) {
            el.classList.add('body-hidden');
        } else {
            el.classList.remove('body-hidden');
        }
        
    },
    popupCreateProject:(val)=>{
        let el = document.body;
        if (val) {
            el.classList.add('body-hidden');
        } else {
            el.classList.remove('body-hidden');
        }
        
    },
    popupcreateticket:(val)=>{
        let el = document.body;
        if (val) {
            el.classList.add('body-hidden');
        } else {
            el.classList.remove('body-hidden');
        }
        
    },
   
 
  }


}
</script>
<style  lang="scss">

.con-expand-users {
  .con-btns-user {
        display: flex;
        padding: 10px;
        padding-bottom: 0px;
        align-items: center;
        justify-content: space-between;
        .con-userx {
        display: flex;
        align-items: center;
        justify-content :flex-start;
            .list-icon {
                i{ font-size: .9rem !important;}
            }
        }
    }
}
.not-data-table  {display:none;}
 
.multiselect .multiselect__content-wrapper ul li .multiselect__option:after {    display: inline-block !important;
    content: attr(data-select);
    background: #41b883;    position: absolute;
    right: 5px;padding: 0 10px;
    color: #fff;}
</style>